import { PicturePlaceholder as PicturePlaceholderIcon } from '../icons';

/**
 * Subtle fallback shown when an image URL is missing or fails to load.
 * Fills 100% of its parent, inherits border-radius, scales the inner icon
 * relative to the wrapper's smallest dimension (30%, capped at 48px).
 *
 * A two-stop diagonal white-on-white gradient gives it a soft glassy look
 * that reads well over both dark hero surfaces and light paper cards.
 */
export function ImagePlaceholder() {
  return (
    <div
      aria-hidden
      className="
        absolute inset-0 flex items-center justify-center rounded-[inherit]
        [background:linear-gradient(135deg,rgba(255,255,255,0.10)_0%,rgba(255,255,255,0.02)_100%)]
      "
    >
      <PicturePlaceholderIcon
        className="h-[30%] w-[30%] max-h-12 max-w-12 text-white/30"
      />
    </div>
  );
}
